import React from 'react'
import './style.scss'
import {Link} from 'react-router-dom'
import img from '../../assets/CollegeLogo.png'

 const Navbar = (props) => {
     function myfun(){
         document.getElementById("check").checked = false;
     }

    const club="<club/>"
    //let auth = JSON.parse(localStorage.getItem('auth'));

    return (
        props.auth ? 
        <nav className="nav" id="nav">
            <div className="logo">
                <span><img src={img} alt="logo" /></span>
            </div>
            <div className="navigationbox">
            <label htmlFor="check" className="scroll">
            ≡
            </label>
            <input type="checkbox" id="check"/>
            <ul>
                <li><Link to="/" onClick={myfun}>Home</Link></li>
                <li><Link to="#" onClick={myfun}>Events</Link></li>
                <li><Link to="/about" onClick={myfun}>About Us</Link></li>
                <li><Link to="/blogs" onClick={myfun}>Blogs</Link></li>
                <li><Link to="#footer" onClick={myfun}>Contact Us</Link></li>
                <li><Link to="/logout" onClick={myfun} className="login">Sign Out</Link></li>
                <li><Link to="/profile" onClick={myfun}  className="register">Profile</Link></li>
                
                <li></li>
            </ul>
            {/* This is extra login-sinup button which will only visible in mobile view to direct access login page for customer relaxatation */}
            <span className="mobileLogin">
                <li><Link to="/login" className="login">Login</Link></li>
                </span>
                <span className="mobileLogin">
                <li><Link to="/register" className="register">SignUp</Link></li>
                </span>
            </div>
        </nav>
        :
        <nav className="nav" id="nav">
           
            
            <div className="logo"><img src={img} alt="" /></div>
            <div className="navigationbox">
            
            <label htmlFor="check" className="scroll">
            ≡
            </label>
            <input type="checkbox" id="check"/>
            <ul>
            
                <li><Link to="/" onClick={myfun}>Home</Link></li>
                <li><Link to="#" onClick={myfun}>Events</Link></li>
                <li><Link to="/about" onClick={myfun}>About Us</Link></li>
                <li><Link to="blogs" onClick={myfun}>Blogs</Link></li>
                <li><Link to="#footer" onClick={myfun}>Contact Us</Link></li>
                <li><Link to="/login" onClick={myfun} className="login">Sign In</Link></li>
                <li><Link to="/register" onClick={myfun} className="register">Sign Up</Link></li>
                <li></li>
               
                
            </ul>
            {/* This is extra login-sinup button which will only visible in mobile view to direct access login page for customer relaxatation */}
            <span className="mobileLogin">
                <li><Link to="/login" className="login">Login</Link></li>
                </span>
                <span className="mobileLogin">
                <li><Link to="/register" className="register">SignUp</Link></li>
                </span>
            
            
             
            </div>
        </nav>
    )
}
export default Navbar;